import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { PlcBatchRecord } from '@cco/model';
import { DefaultDataService } from '@ngrx/data';
import { APP_CONFIG, AppConfig } from '@cco-apps/cco-frontend';
import { CcoHttpUrlGenerator } from '@app/store/cco-http-url-generator';

@Injectable({
  providedIn: 'any'
})
export class PlcBatchRecordDataService extends DefaultDataService<PlcBatchRecord> {
  constructor() {
    const config = inject<AppConfig>(APP_CONFIG);
    const http = inject(HttpClient);
    const httpUrlGenerator = inject(CcoHttpUrlGenerator);

    super('PlcBatchRecord', http, httpUrlGenerator, {
      root: config.cloudApiBaseUrl,
    });
  }
}
